var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { alpha, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { addGeofenceCheckedId, setFilterTab } from 'app/actions/map';
import { MapTransportConditionIconsList, MapTransportTaskList } from 'app/pages/Map';
import { hasTransportTask } from 'app/pages/Map/MapTransportTaskList';
import { useAsyncAction } from 'app/services';
import { transportTaskLoad } from 'app/store/map';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Tooltip } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
const MapLeafletTransportTooltip = function (props) {
    const dispatch = useDispatch();
    const { value, datetime } = props, rest = __rest(props, ["value", "datetime"]);
    const { zoom, ref: mapRef, filterTab, geofenceCheckedId } = useSelector((state) => state.map);
    const [infoOpen, setInfoOpen] = useState(false);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportTaskLoad);
    const maxWidth = useMemo(() => {
        return config.mapTransportTaskColumns.reduce((accumulator, column) => accumulator + column.width, 24);
    }, []);
    const handleItemColumnClick = useCallback((value) => {
        var _a, _b, _c, _d;
        if (geofenceCheckedId.indexOf(value.geofence_id) === -1) {
            dispatch(addGeofenceCheckedId(value.geofence_id));
        }
        if (filterTab !== 'geofence') {
            dispatch(setFilterTab('geofence'));
        }
        (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [value.latitude, value.longitude]);
    }, [mapRef, filterTab, geofenceCheckedId]);
    useEffect(() => {
        if (infoOpen) {
            fetchData(value.id);
        }
    }, [infoOpen]);
    return (React.createElement(Tooltip, Object.assign({ direction: 'bottom', className: 'leaflet-tooltip-bottom-transport', maxWidth: maxWidth }, rest),
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                bgcolor: 'background.paper',
                overflow: 'hidden',
                borderRadius: theme.shape.borderRadius,
            }) },
            React.createElement(Stack, { direction: 'row', justifyContent: 'center', onClick: () => setInfoOpen(!infoOpen), sx: {
                    fontSize: '12px',
                    position: 'relative',
                    '&:hover': {
                        bgcolor: 'background.default',
                    },
                } },
                React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: (theme) => (Object.assign(Object.assign({ padding: '4px 6px', color: theme.palette.common.black }, (infoOpen && {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    })), { '.MuiTypography-root': {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'center',
                            fontSize: '12px',
                        } })) },
                    React.createElement(Typography, { variant: 'body1' }, value.name)),
                React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                        padding: '4px 6px',
                        marginLeft: 'auto',
                        div: {
                            display: 'flex',
                            marginRight: '2px',
                            svg: {
                                fontSize: '18px',
                            },
                        },
                        'div:last-of-type': {
                            marginRight: theme.spacing(0),
                        },
                        button: {
                            padding: '2px',
                            svg: {
                                fontSize: '20px',
                            },
                        },
                    }) },
                    React.createElement(MapTransportConditionIconsList, { data: value, history: false, datetime: datetime, zoom: zoom === config.mapMinTransportTooltipZoom, conditions: value.conditions }))),
            infoOpen && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    fontSize: '12px',
                    bgcolor: 'background.paper',
                    minWidth: maxWidth,
                } },
                React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                        padding: theme.spacing(2),
                    }) },
                    !isFetchLoading && hasTransportTask(value) && (React.createElement(React.Fragment, null,
                        React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                                display: 'grid',
                                gap: 2,
                                marginBottom: theme.spacing(1),
                                '.MuiPaper-root': {
                                    position: 'relative',
                                    border: 'none',
                                    display: 'grid',
                                    gap: '6px',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                },
                                '.MuiPaper-row': {
                                    display: 'grid',
                                    gap: 1,
                                    gridTemplateColumns: 'repeat(6, 1fr)',
                                    '.MuiTypography-root:first-of-type': {
                                        color: 'text.secondary',
                                    },
                                },
                                '.MuiPaper-row .MuiTypography-root:first-of-type': {
                                    gridRow: '1',
                                    gridColumn: '1/4',
                                },
                                '.MuiPaper-row .MuiTypography-root:last-of-type': {
                                    gridRow: '1',
                                    gridColumn: '4/7',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    'span:nth-of-type(2)': {
                                        paddingLeft: theme.spacing(0.5),
                                    },
                                },
                            }) },
                            React.createElement(Paper, { variant: 'outlined' },
                                React.createElement(Stack, { className: 'MuiPaper-column' },
                                    React.createElement(Stack, { className: 'MuiPaper-row' },
                                        React.createElement(Typography, { variant: 'body1' }, "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                        React.createElement(Typography, { variant: 'body1' }, value.task.id)),
                                    React.createElement(Stack, { className: 'MuiPaper-row' },
                                        React.createElement(Typography, { variant: 'body1' }, "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                        React.createElement(Typography, { variant: 'body1' }, {
                                            finished: 'Завершено',
                                            active: 'Активно',
                                        }[value.task.status]))),
                                React.createElement(Stack, { className: 'MuiPaper-column' },
                                    React.createElement(Stack, { className: 'MuiPaper-row' },
                                        React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430"),
                                        React.createElement(Typography, { variant: 'body1' }, moment(value.task.task_date).format('DD.MM.YYYY HH:mm:ss'))),
                                    React.createElement(Stack, { className: 'MuiPaper-row' },
                                        React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F"),
                                        React.createElement(Typography, { variant: 'body1' }, moment(value.task.finished_date).isValid() && moment(value.task.finished_date).format('DD.MM.YYYY HH:mm:ss')))))),
                        React.createElement(MapTransportTaskList, { value: value, onItemColumnClick: handleItemColumnClick }))),
                    !isFetchLoading && !value.task && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                            padding: theme.spacing(2),
                            '.MuiTypography-root': {
                                textAlign: 'center',
                            },
                        }) },
                        React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                        React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u0412 \u044D\u0442\u043E\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0437\u0430\u0434\u0430\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430"))),
                    isFetchLoading && (React.createElement(Stack, { direction: 'row', justifyContent: 'center', sx: (theme) => ({
                            width: '100%',
                            height: '100%',
                            padding: theme.spacing(2),
                        }) },
                        React.createElement(CircularProgress, { size: 18 })))))),
            React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    display: 'none',
                    fontSize: '12px',
                    bgcolor: 'background.default',
                    cursor: 'pointer',
                    color: theme.palette.text.secondary,
                    '&:hover': {
                        bgcolor: alpha(theme.palette.grey.main, 0.12),
                    },
                }) },
                React.createElement(Typography, { variant: 'body1' }, "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C")))));
};
export default MapLeafletTransportTooltip;
